import { Tab } from '@vgrubs/components';
import styled from 'styled-components';

/**
 * Deliberately NOT its own scroll container.
 *
 * A bounded list inside a modal that also scrolls gives two nested scrollbars
 * and a list that grows and shrinks the modal underneath it. The modal is
 * pinned to one height instead (see `MODAL_HEIGHT`) and does the scrolling, so
 * the tabs, the search field and the create button never move.
 *
 * The negative margin gives the boxes' 30px drop shadow room; without it the
 * first and last rows look clipped against the edges.
 */
export const CandidateList = styled.div`
  margin: 12px -4px 0;
  padding: 4px;
`;

/** Support / Direct / Group, sharing one row rather than `Tab`'s 200px floor. */
export const ModeTab = styled(Tab)`
  flex: 1;
  min-width: 0;
  width: auto;
`;

/**
 * "Opened" - this person already has a thread with us.
 *
 * Context, not a block: opening a support or direct conversation is idempotent
 * on the backend, so the row stays clickable and simply lands you in the thread
 * that already exists. Grey for exactly that reason - it is a statement of
 * fact, not a warning, and the same geometry as the inbox's "Waiting" chip so
 * the two read as one kind of marker.
 */
export const OpenedChip = styled.span`
  flex: none;
  padding: 1px 8px;
  border-radius: 8px;
  font-size: 11px;
  line-height: 16px;
  background: ${({ theme }) => theme.gray};
  color: ${({ theme }) => theme.lightGray};
`;
